import React from 'react';
import {Grid, Typography} from '@material-ui/core';
import StyledPaper from './shared/StyledPaper';

/**
 * Rate completed (default)
 */
const RateComplete = () => {
  return (
      <Grid container direction={'column'} spacing={2}>
        <Grid container item xs={12}>
          <StyledPaper>
            <Typography variant={'body1'}>
              Спасибо за ваш голос.
              <br/>Ваше мнение очень важно для нас.
            </Typography>
          </StyledPaper>
        </Grid>
      </Grid>
  );
};

export default RateComplete;
